import type {DataMessagePartComponent} from '@assistant-ui/react';
import React from 'react';

import {ArtifactCollectionPill} from '../../../components/ArtifactOverview/ArtifactCollectionPill';
import type {WandbArtifactCollectionPart} from '../../chat/store/thread';

/**
 * ArtifactCollectionMentionPart renders an artifact collection mention as an
 * inline pill.
 */
export const ArtifactCollectionMentionPart: DataMessagePartComponent<
  WandbArtifactCollectionPart
> = ({data}) => <ArtifactCollectionPill collectionId={data.collectionId} />;
